import { QueryClient } from '@tanstack/react-query';

/**
 * Defaults tuned for the actual users: commission-driven reps on phones, in the
 * field, on poor connections (CLAUDE.md). `offlineFirst` means a cached screen
 * still renders when the radio drops instead of throwing; retries are bounded so
 * a dead connection fails fast rather than hanging the UI.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      networkMode: 'online',
      retry: 0,
    },
  },
});
